'use client'

import { useState, useEffect } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { Link as RouterLink, useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { auth, db } from '../firebase/firebase'
import { signOut, onAuthStateChanged } from 'firebase/auth'
import { doc, getDoc } from 'firebase/firestore'
import logo from "../dosyalar/Başlıksız-1.png"
const navigation = [
  { name: 'Anasayfa', href: '/', isScroll: false },
  { name: 'Hakkımda', href: '/hakkimda', isScroll: false },
  { name: 'Çalışma Alanları', href: '/calisma-alanlari', isScroll: false },
  { name: 'Eğitimler', href: '/egitimler', isScroll: false },
  { name: 'Seans Süreci', href: '/hizmetlerimiz', isScroll: false },
  { name: 'Videolar', href: '/videolar', isScroll: false },
  { name: 'Blog', href: '/blog', isScroll: false },
  { name: 'İletişim', href: '/iletisim', isScroll: false },
  { name: 'S.S.S', href: '/sss', isScroll: false },
]

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [user, setUser] = useState(null)
  const [isAdmin, setIsAdmin] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser)

        const docRef = doc(db, "users", currentUser.uid)
        const docSnap = await getDoc(docRef)

        if (docSnap.exists()) {
          const userData = docSnap.data()
          setIsAdmin(userData.role === "admin")
        } else {
          setIsAdmin(false)
        }
      } else {
        setUser(null)
        setIsAdmin(false)
      }
    })

    return unsubscribe
  }, [])

  const handleLogout = async () => {
    await signOut(auth)
    navigate('/login')
  }

  const scrollToSection = (id) => {
    if (window.location.pathname !== "/") {
      navigate("/")

      setTimeout(() => {
        const el = document.getElementById(id)
        if (el) el.scrollIntoView({ behavior: "smooth" })
      }, 100)
    } else {
      const el = document.getElementById(id)
      if (el) el.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="bg-white inset-x-0 top-0 z-50"
    >
      <nav className="flex items-center border-b justify-between px-6 py-4 lg:px-8">

        <div className="flex lg:flex-1">
  <RouterLink to="/" className="flex items-center gap-3">
    <img
      src={logo}
      alt="Aysun Şeremet Logo"
      className="h-10 w-10 object-contain text-green-600"
    />
    <div className="flex flex-col">
      <span className="font-handwriting text-[22px] leading-tight text-gray-900">
        Aysun Şeremet
      </span>
      <div className="w-7 h-[2px] bg-pink-500 mt-[3px] mb-[2px] rounded-full" />
      <span className="font-subtitle text-[9px] font-extralight tracking-[0.25em] uppercase text-gray-400">
        Uzman Klinik Psikolog
      </span>
    </div>
  </RouterLink>
</div>

        <div className="hidden lg:flex lg:gap-x-5">
          {navigation.map((item) =>
            item.isScroll ? (
              <button
                key={item.name}
                onClick={() => scrollToSection(item.href)}
                className="text-sm font-semibold text-gray-900 hover:text-gray-600"
              >
                {item.name}
              </button>
            ) : (
              <RouterLink
                key={item.name}
                to={item.href}
                className="text-sm font-semibold text-gray-900 hover:text-gray-600"
              >
                {item.name}
              </RouterLink>
            )
          )}

          {isAdmin && (
            <RouterLink
              to="/admin"
              className="text-sm font-semibold text-purple-600 hover:text-purple-800"
            >
              Admin Panel
            </RouterLink>
          )}
        </div>

        <div className="hidden lg:flex lg:flex-1 lg:justify-end gap-4">
          {user ? (
            <button
              onClick={handleLogout}
              className="text-sm font-semibold text-gray-900 hover:text-gray-600"
            >
              Çıkış Yap →
            </button>
          ) : (
            <RouterLink
              to="/login"
              className="text-sm font-semibold text-gray-900 hover:text-gray-600"
            >
              Giriş Yap →
            </RouterLink>
          )}
        </div>

        <div className="flex lg:hidden">
          <button
            onClick={() => setMobileMenuOpen(true)}
            className="p-2 text-gray-700"
          >
            <Bars3Icon className="h-6 w-6" />
          </button>
        </div>
      </nav>

      <Dialog
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
        className="lg:hidden"
      >
        <div className="fixed inset-0 z-50 bg-black/20 backdrop-blur-sm" />

        <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full bg-white p-6 sm:max-w-sm">
          <div className="flex justify-between items-center">
            <RouterLink to="/" className="flex flex-col">
              <span className="font-handwriting text-xl leading-tight text-gray-900">
                Aysun Şeremet
              </span>
              <div className="w-6 h-[2px] bg-pink-500 mt-[2px] mb-[1px] rounded-full" />
              <span className="font-subtitle text-[8px] font-extralight tracking-[0.25em] uppercase text-gray-400">
                Uzman Klinik Psikolog
              </span>
            </RouterLink>

            <button onClick={() => setMobileMenuOpen(false)}>
              <XMarkIcon className="h-6 w-6" />
            </button>
          </div>

          <div className="mt-6 space-y-3">
            {navigation.map((item) =>
              item.isScroll ? (
                <button
                  key={item.name}
                  onClick={() => {
                    scrollToSection(item.href)
                    setMobileMenuOpen(false)
                  }}
                  className="block w-full text-left px-3 py-2 font-semibold"
                >
                  {item.name}
                </button>
              ) : (
                <RouterLink
                  key={item.name}
                  to={item.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className="block px-3 py-2 font-semibold"
                >
                  {item.name}
                </RouterLink>
              )
            )}

            {isAdmin && (
              <RouterLink
                to="/admin"
                onClick={() => setMobileMenuOpen(false)}
                className="block px-3 py-2 font-semibold text-pink-600"
              >
                Admin Panel
              </RouterLink>
            )}

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
            >
              {user ? (
                <button
                  onClick={() => {
                    handleLogout()
                    setMobileMenuOpen(false)
                  }}
                  className="block w-full text-left px-3 py-2 font-semibold text-red-600"
                >
                  Çıkış Yap
                </button>
              ) : (
                <RouterLink
                  to="/login"
                  onClick={() => setMobileMenuOpen(false)}
                  className="block px-3 py-2 font-semibold text-pink-600"
                >
                  Giriş Yap
                </RouterLink>
              )}
            </motion.div>
          </div>
        </DialogPanel>
      </Dialog>
    </motion.header>
  )
}